import { cloneDeep } from 'lodash';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
var state = {
    job: null,
    assignees: null,
    referrerName: 'Jobs.Index',
    startTime: null,
};
export var types = {
    SET_JOB: 'setJob',
    SET_ASSIGNEES: 'setAssignees',
    SET_REFERRER_NAME: 'setReferrerName',
    SET_START_TIME: 'setStartTime',
    SET_ATTACHED_ATTRIBUTES: 'setAttachedAttributes',
};
export var jobWizard = {
    namespaced: true,
    state: cloneDeep(state),
    actions: actions,
    getters: getters,
    mutations: mutations,
};
